import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { formatOptionalDate } from "./formatters";
import { PasswordField, PasswordRequirements } from "./password";
export default function AdminDevelopersView({ portal }) {
  const {
    developers: {
      adminDeveloperForm,
      adminDevelopers,
      handleCreateDeveloper,
      handleDeleteDeveloper,
      handleEditDeveloper,
      isDeveloperEditorOpen,
      isEditingDeveloper,
      openCreateDeveloperForm,
      resetDeveloperForm,
      setAdminDeveloperForm,
      setShowAdminDeveloperPassword,
      showAdminDeveloperPassword,
    },
    ui: { loading },
  } = portal;

  const renderDeveloperEditorForm = () => (
    <div className="support-inline-editor">
      <div className="support-inline-editor-head">
        <div className="support-panel-heading">
          <h3 className="heading-3">{isEditingDeveloper ? "Modifier un developpeur" : "Ajouter un developpeur"}</h3>
          <p className="body-small">
            Gere l'acces plateforme et conserve l'historique meme si le compte est bloque.
          </p>
        </div>
        <button type="button" className="support-inline-close" onClick={resetDeveloperForm} aria-label="Fermer le bloc d'edition">
          ×
        </button>
      </div>
      <form onSubmit={handleCreateDeveloper} className="support-form-grid">
        <input
          className="form-input"
          type="text"
          placeholder="Nom du developpeur"
          value={adminDeveloperForm.full_name}
          onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, full_name: e.target.value })}
          required
        />
        <input
          className="form-input"
          type="email"
          placeholder="Email du developpeur"
          value={adminDeveloperForm.email}
          onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, email: e.target.value })}
          required
        />
        <div className="support-span-2">
          <PasswordField
            value={adminDeveloperForm.password}
            onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, password: e.target.value })}
            placeholder={isEditingDeveloper ? "Nouveau mot de passe (optionnel)" : "Mot de passe initial"}
            required={!isEditingDeveloper}
            isVisible={showAdminDeveloperPassword}
            onToggleVisibility={() => setShowAdminDeveloperPassword((current) => !current)}
          />
        </div>
        <div className="support-span-2">
          <PasswordRequirements password={adminDeveloperForm.password} />
        </div>
        <label className="support-checkbox-line support-span-2">
          <input
            type="checkbox"
            checked={adminDeveloperForm.can_access_platform}
            onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, can_access_platform: e.target.checked })}
          />
          Acces autorise a la plateforme
        </label>
        <div className="support-form-actions support-span-2">
          <Button type="submit" className="btn-primary" disabled={loading}>
            {loading ? (isEditingDeveloper ? "Mise a jour..." : "Creation...") : (isEditingDeveloper ? "Mettre a jour" : "Creer l'acces")}
          </Button>
          <Button type="button" className="btn-secondary" onClick={resetDeveloperForm} disabled={loading}>
            Annuler
          </Button>
          {isEditingDeveloper && (
            <Button
              type="button"
              className="btn-secondary support-danger-btn"
              onClick={handleDeleteDeveloper}
              disabled={loading}
            >
              Bloquer le compte
            </Button>
          )}
        </div>
      </form>
    </div>
  );

  return (
    <Card className="support-content-card">
      <CardHeader>
        <CardTitle className="heading-2">Developpeurs</CardTitle>
      </CardHeader>
      <CardContent className="support-management-list">
        <div className="support-list-toolbar">
          <div>
            <p className="body-small">Clique une ligne pour modifier, ou ajoute un nouvel acces.</p>
          </div>
          <Button type="button" className="btn-primary" onClick={openCreateDeveloperForm}>
            Ajouter un developpeur
          </Button>
        </div>
        {isDeveloperEditorOpen && !isEditingDeveloper && renderDeveloperEditorForm()}

        <div className="support-table-list">
          <div className="support-table-row support-table-head" aria-hidden="true">
            <span>Developpeur</span>
            <span>Email</span>
            <span>Acces</span>
            <span>Tickets attribues</span>
            <span>Clients geres</span>
            <span>Derniere connexion</span>
          </div>
          {adminDevelopers.map((developer) => (
            <div key={developer.id} className="support-table-item">
              <button
                type="button"
                className={`support-table-row ${adminDeveloperForm.id === developer.id ? "is-active" : ""}`}
                onClick={() => handleEditDeveloper(developer)}
              >
                <strong>{developer.full_name}</strong>
                <span>{developer.email}</span>
                <span>{developer.can_access_platform && developer.is_active ? "Actif" : "Bloque"}</span>
                <span>{developer.assigned_ticket_count} ticket(s) attribue(s)</span>
                <span>{developer.managed_client_count} client(s) gere(s)</span>
                <span>{formatOptionalDate(developer.last_login_at)}</span>
              </button>
              {isDeveloperEditorOpen && adminDeveloperForm.id === developer.id && renderDeveloperEditorForm()}
            </div>
          ))}
          {adminDevelopers.length === 0 && <p className="body-small">Aucun developpeur pour le moment.</p>}
        </div>
      </CardContent>
    </Card>
  );
}
